<app-side-dialog (closeDialog)="onCloseClick()">
  <div dialogHeader>
    <div>
      <h2>
        @if (data.invitation) {
          {{ 'pages.admin.userGroup.tabs.invitations.dialog.editTitle' | translate }}
        } @else {
          {{ 'pages.admin.userGroup.tabs.invitations.dialog.createTitle' | translate }}
        }
      </h2>
    </div>
  </div>

  <div class="dialog-content" dialogContent>
    @if (data.invitation) {
      <div class="flex items-center gap-2 mb-4">
        @if (data.invitation.createdUserId) {
          <span class="rounded-full bg-shikenso-success-base w-4 h-4"></span>
          <span>{{ 'shared.statuses.joined' | translate }}</span>
        } @else if (invitationExpired()) {
          <span class="rounded-full bg-shikenso-error-base w-4 h-4"></span>
          <span>
            {{ 'shared.statuses.expired' | translate }}
          </span>
          <span class="text-sm text-shikenso-purple-base-60">
            ({{
              'pages.admin.userGroup.tabs.invitations.dialog.expiredOn'
                | translate: { expiryDate: (invitationExpiryDate() | date: 'dd.MM.yyyy HH:mm') }
            }})
          </span>
        } @else {
          <span class="rounded-full bg-shikenso-warning-base w-4 h-4"></span>
          <span>
            {{ 'shared.statuses.pending' | translate }}
          </span>
          <span class="text-sm text-shikenso-purple-base-60">
            ({{
              'pages.admin.userGroup.tabs.invitations.dialog.expiresOn'
                | translate: { expiryDate: (invitationExpiryDate() | date: 'dd.MM.yyyy HH:mm') }
            }})
          </span>
        }
      </div>
    }

    <form class="custom-form custom-form-readonly" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (hasRoleField()) {
        <mat-form-field class="w-full mb-4">
          <mat-label>{{ 'pages.admin.userGroup.tabs.invitations.role' | translate }}</mat-label>
          <mat-select formControlName="role" (selectionChange)="onRoleChange($event.value)">
            @for (option of roleOptions; track option.value) {
              <mat-option *hasPermission="[option.value + invitationPermissionSuffix]" [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
          <mat-error [control]="form.get('role')" />
        </mat-form-field>
      }

      <mat-form-field class="w-full mb-4">
        <mat-label>{{ 'shared.email' | translate }}</mat-label>
        <input matInput formControlName="email" type="email" />
        <mat-error [control]="form.get('email')" />
      </mat-form-field>

      @if (hasClientNameField()) {
        <mat-form-field class="w-full mb-4">
          <mat-label>{{ 'pages.admin.userGroup.tabs.invitations.dialog.clientName' | translate }}</mat-label>
          <input matInput formControlName="clientName" />
          <mat-error [control]="form.get('clientName')" />
        </mat-form-field>
      }

      @if (hasMessageField()) {
        <mat-form-field class="w-full mb-4">
          <mat-label>{{ 'shared.message' | translate }}</mat-label>
          <textarea matInput formControlName="message" rows="4"></textarea>
        </mat-form-field>
      }

      @if (store.invitation$()) {
        <mat-form-field class="w-full mb-4">
          <mat-label>{{ 'pages.campaignDetails.export.link' | translate }}</mat-label>
          <input matInput formControlName="link" />
          <button matSuffix mat-icon-button type="button" (click)="onCopyLinkClick()">
            <app-icon src="/icons/copy.svg" alt="copy" [size]="16" />
          </button>
        </mat-form-field>
      }

      @if (store.invitation$() && !store.invitation$()?.emailSent) {
        <p class="text-shikenso-error-base text-sm font-medium">
          {{ 'pages.admin.userGroup.tabs.invitations.dialog.emailNotSent' | translate }}
        </p>
      }

      <div class="flex items-center justify-between gap-6 mt-6">
        @if (store.invitation$()) {
          <button mat-flat-button type="button" color="danger" [disabled]="store.loading$()" (click)="onRevokeClick()">
            @if (store.loading$() && !isSendRequest()) {
              <app-dots-spinner />
            } @else {
              {{ 'shared.revoke' | translate }}
            }
          </button>
        } @else {
          <div></div>
        }

        <div class="flex items-center gap-2">
          <button mat-flat-button color="secondary-transparent" type="button" (click)="onCloseClick()">
            {{ 'shared.cancel' | translate }}
          </button>

          @if (hasRoleField()) {
            <button mat-flat-button type="submit" [disabled]="store.loading$() || data.invitation?.createdUserId">
              @if (store.loading$() && isSendRequest()) {
                <app-dots-spinner />
              } @else {
                @if (data.invitation) {
                  {{ 'shared.resend' | translate }}
                } @else {
                  {{ 'shared.send' | translate }}
                }
              }
            </button>
          }
        </div>
      </div>
    </form>
  </div>
</app-side-dialog>
